<app-video-background
    class="survey-video"
    [source]="videoName"
    [background]="videoBackground"
    [showLogo]="showLogo"
    [showAnonymous]="showAnonymous"
    [class.fadeOut]="fadeOut"
  >
  <div class="content">
    <app-pill class="pill">
      <app-pill-progress-bar
        class="progress-bar"
        [title]="currentMenuItemSignal()?.title ?? ''"
        [titleIcon]="currentMenuItemSignal()?.icon ?? ''"
        [progress]="100"
        [nextTitle]="nextAvailableMenuItem()?.title ?? ''"
        [nextTitleIcon]="nextAvailableMenuItem()?.icon ?? ''"
      ></app-pill-progress-bar>
    </app-pill>

    <div class="insights">
      @if (show3Columns || showFirstPart) {
        <div class="column">
          <div class="date blue">{{chartDate}}</div>
          <div class="title chart" [style.color]="chartTextColor">{{chartTextTitle | translate}}</div>
          <app-chart class="chart" [configuration]="configuration"></app-chart>
          
          @if (!isBodyIntervention) {
            <div class="button-container stats">
              <app-button class="button stats"
                iconLeft="fa-solid fa-chart-simple"
                iconColor="#2CDAFF"
                [label]="'WebApp.v1.Shared.Buttons.Stats' | translate"
                [fontSize]="14"
                backgroundColor="transparent"
                (click)="onGoToStats()"
              ></app-button>
            </div>
          }
        </div>
        <div class="column text-result">
          <div class="date blue">{{ currentDate }}</div>
          @if (surveyIntervention?.title) {
            <div class="title white">{{surveyIntervention?.title}}</div>
          }
          <div
            class="text"
            [class.mind]="!isBodyIntervention"
            [innerHTML]="surveyIntervention?.body | markdown">
          </div>
          @if (surveyIntervention?.disclaimer) {
            <div class="note margin-top-15">{{surveyIntervention?.disclaimer}}</div>
          }
        </div>
      }

      @if (screenTypeViewSignal() === viewTypes.SmallScreenView || screenTypeViewSignal() === viewTypes.MediumScreenView) {
        <ng-container *ngTemplateOutlet="actionsSmallMedium"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="actionsBig"></ng-container>
      }
    </div>
  </div>
</app-video-background>

@if (showResponseTeamVideo || fadeOut) {
  <div class="video-container howdy-video" [class.fade-out]="fadeOut" [class.fade-in]="fadeIn">
    <i class="fa-solid fa-xmark close-button" (click)="closeHowdyVideo()"></i>
    <video class="video" controls autoplay>
      <source [src]="s3BaseUrl + 'assets/videos/responseTeamIntro' + languageId + videoFormat" type="video/mp4">
    </video>
  </div>
}

<ng-template #actionsBig>
  <div class="column">
    <div class="request-call" [class.fade]="actionContainerTransition" [class.smaller]="screenTypeViewSignal() !== viewTypes.BigScreenView">
      <div class="title call" [ngClass]="actionSignal() === actionTypes.RequestCall ? 'green' : 'white'">
        {{ actionTitle | translate: { nextSurvey: nextSurveyTitle } }}
      </div>

      @if (actionSignal() === actionTypes.AddNote) {
        <ng-container *ngTemplateOutlet="noteContainer"></ng-container>
      }

      <div class="button-container call"
        [class.hidden]="actionSignal() === actionTypes.GoToNext"
        [class.margin-top-30]="actionSignal() === actionTypes.AddNote"
      >
        @if (actionSignal() === actionTypes.NoAction) {
          <app-button class="button"
            iconLeft="fa-solid fa-check"
            [label]="'WebApp.v1.Shared.Buttons.Yes' | translate"
            iconColor="#57DF8E"
            [fontSize]="14"
            backgroundColor="transparent"
            [disabled]="disableButton"
            [waitCursor]="disableButton"
            (click)="onContactMe()"
          ></app-button>

          <app-button class="button"
            iconLeft="fa-solid fa-ban"
            iconColor="#c53333"
            [label]="'WebApp.v1.Shared.Buttons.No' | translate"
            [fontSize]="14"
            backgroundColor="transparent"
            (click)="goToStep(actionTypes.GoToNext)"
          ></app-button>
        } @else if (actionSignal() === actionTypes.RequestCall) {
          <app-button class="button"
            iconLeft="fa-solid fa-file-lines"
            iconColor="#56fa98"
            [label]="'WebApp.v1.Shared.Buttons.AddNote' | translate"
            [fontSize]="14"
            backgroundColor="transparent"
            (click)="goToStep(actionTypes.AddNote)"
          ></app-button>
        } @else if (actionSignal() === actionTypes.AddNote) {
          <app-button class="button"
            iconLeft="fa-solid fa-check"
            iconColor="#56fa98"
            [label]="'WebApp.v1.Shared.Buttons.Send' | translate"
            [fontSize]="14"
            backgroundColor="transparent"
            [disabled]="disableButton"
            [waitCursor]="disableButton"
            (click)="onSendNote()"
          ></app-button>

          <app-button class="button"
            iconLeft="fa-solid fa-ban"
            iconColor="#c53333"
            [label]="'WebApp.v1.Shared.Buttons.Cancel' | translate"
            [fontSize]="14"
            backgroundColor="transparent"
            (click)="goToStep(actionTypes.RequestCall)"
          ></app-button>
        }
      </div>
    </div>

    @if (actionSignal() === actionTypes.NoAction || actionSignal() === actionTypes.GoToNext || actionSignal() === actionTypes.RequestCall || actionSignal() === actionTypes.NoteSend) {
      <app-button class="button next margin-top-30"
        [iconLeft]="nextAvailableMenuItem()?.icon || ''"
        iconRight="fa-solid fa-play"
        [label]="buttonTitle | translate"
        [fontSize]="20"
        [disabled]="actionSignal() === actionTypes.NoAction"
        (click)="onGoToNextSurvey()"
      ></app-button>
    }
  </div>
</ng-template>

<ng-template #actionsSmallMedium>
  @switch (true) {
    @case (actionSignal() === actionTypes.NoAction) {
      <div
        class="button-container contact-me"
        [class.contact-me-column]="screenTypeViewSignal() === viewTypes.SmallScreenView"
      >
        <app-button class="button mobile"
          [class.small]="screenTypeViewSignal() === viewTypes.MediumScreenView"
          [label]="'WebApp.v1.Shared.Buttons.ContactMe' | translate"
          [fontSize]="buttonFontSize"
          backgroundColor="transparent"
          [disabled]="disableButton"
          [waitCursor]="disableButton"
          (click)="onContactMe()"
        ></app-button>
        <app-button class="button mobile"
          [class.small]="screenTypeViewSignal() === viewTypes.MediumScreenView"
          [label]="'WebApp.v1.Shared.Buttons.NoThanks' | translate"
          [fontSize]="buttonFontSize"
          backgroundColor="transparent"
          (click)="onGoToNextSurvey()"
        ></app-button>
      </div>
    } @case (actionSignal() === actionTypes.RequestCall && actionSignal() !== defaultState) {
      <div class="column center actions">
        <div class="call-booked" [style.display]="actionSignal() === defaultState ? 'none' : 'flex'">
          <div class="circle big">
            <i class="fa fa-solid fa-check"></i>
          </div>

          <div class="title-container">
            <div class="title call white">{{ 'WebApp.v1.Survey.SurveyIntervetion.CallBooked' | translate }}</div>
            <div class="text" [innerHTML]="callBookedDescription | translate | markdown"></div>
          </div>
        </div>

        <div
          class="button-container margin-top-30"
          [class.contact-me-column]="screenTypeViewSignal() === viewTypes.SmallScreenView"
        >
          <app-button class="button mobile"
            [iconLeft]="nextAvailableMenuItem()?.icon || ''"
            [label]="buttonTitle | translate"
            [fontSize]="buttonFontSize"
            (click)="onGoToNextSurvey()"
          ></app-button>

          <app-button class="button mobile"
            iconLeft="fa-solid fa-file-lines"
            iconColor="#56fa98"
            [label]="'WebApp.v1.Shared.Buttons.AddNote' | translate"
            [fontSize]="buttonFontSize"
            backgroundColor="transparent"
            (click)="goToStep(actionTypes.AddNote)"
          ></app-button>
        </div>
      </div>
    } @case (actionSignal() === actionTypes.RequestCall && actionSignal() === defaultState) {
      <div
        class="button-container contact-me"
        [class.contact-me-column]="screenTypeViewSignal() === viewTypes.SmallScreenView"
      >
        <app-button class="button mobile"
          [iconLeft]="nextAvailableMenuItem()?.icon || ''"
          [label]="buttonTitle | translate"
          [fontSize]="buttonFontSize"
          (click)="onGoToNextSurvey()"
        ></app-button>

        <app-button class="button mobile"
          iconLeft="fa-solid fa-file-lines"
          iconColor="#56fa98"
          [label]="'WebApp.v1.Shared.Buttons.AddNote' | translate"
          [fontSize]="buttonFontSize"
          backgroundColor="transparent"
          (click)="goToStep(actionTypes.AddNote)"
        ></app-button>
      </div>
    } @case (actionSignal() === actionTypes.AddNote) {
      <div class="column center actions">
        <div class="title-container">
          <div class="title call white">{{ actionTitle | translate }}</div>
          <div class="text add-note" [innerHTML]="callBookedDescription | translate | markdown"></div>
        </div>

        <ng-container *ngTemplateOutlet="noteContainer"></ng-container>

        <div class="button-container margin-top-30"
          [class.contact-me-column]="screenTypeViewSignal() === viewTypes.SmallScreenView"
        >
          <app-button class="button mobile"
            iconLeft="fa-solid fa-check"
            iconColor="#56fa98"
            [label]="'WebApp.v1.Shared.Buttons.Send' | translate"
            [fontSize]="buttonFontSize"
            backgroundColor="transparent"
            [disabled]="noteForm.invalid || disableButton"
            [waitCursor]="disableButton"
            (click)="onSendNote()"
          ></app-button>

          <app-button class="button mobile"
            iconLeft="fa-solid fa-ban"
            iconColor="#c53333"
            [label]="'WebApp.v1.Shared.Buttons.Cancel' | translate"
            [fontSize]="buttonFontSize"
            backgroundColor="transparent"
            (click)="goToStep(actionTypes.RequestCall)"
          ></app-button>
        </div>
      </div>
    } @case (actionSignal() === actionTypes.NoteSend) {
      <div class="column actions">
        <div class="title call" [ngClass]="actionSignal() === actionTypes.RequestCall ? 'green' : 'white'">
          {{ actionTitle | translate: { nextSurvey: nextSurveyTitle } }}
        </div>

        <div class="button-container margin-top-30"
          [class.contact-me-column]="screenTypeViewSignal() === viewTypes.SmallScreenView"
        >
          <app-button class="button mobile"
            [iconLeft]="nextAvailableMenuItem()?.icon || ''"
            iconRight="fa-solid fa-arrow-right"
            [label]="buttonTitle | translate"
            [fontSize]="buttonFontSize"
            (click)="onGoToNextSurvey()"
          ></app-button>
        </div>
      </div>
    } @case (actionSignal() === actionTypes.GoToNext) {
      <div
        class="button-container contact-me center"
        [class.contact-me-column]="screenTypeViewSignal() === viewTypes.SmallScreenView"
      >
        <app-button class="button mobile"
          [iconLeft]="nextAvailableMenuItem()?.icon || ''"
          iconRight="fa-solid fa-arrow-right"
          [label]="buttonTitle | translate"
          [fontSize]="buttonFontSize"
          (click)="onGoToNextSurvey()"
        ></app-button>
      </div>
    }
  }
</ng-template>

<ng-template #noteContainer>
  <form class="note-container" [class.fade]="noteTransition" [formGroup]="noteForm">
    <textarea
      class="note-textarea white"
      formControlName="noteControl"
      placeholder="Write your note..."
    ></textarea>
  </form>
</ng-template>
